module.exports = __webpack_public_path__ + "static/media/agronomists-doing-quality-control-hemp-field-min.c884ee08.jpg";